/* eslint-disable max-len */
import React, { useState } from 'react';

import cn from 'classnames';

import Icon from '@components/Icon';
import { Popover } from '@element/index';
// import React from 'react';
import I18n from '@utils/i18n';
import SearchDrawer from '@widget/market/SearchDrawer'

import { Synopsis } from '../Synopsis';

import styles from './index.module.css';

export const CoinTag = ({ text, className, coinDetail }) => {
  const [visible, setVisible] = useState(false);
  return (
    <div className={cn(styles.wrapper, className)}>
      <div className={styles.main} onClick={() => setVisible(true)}>
        <span className={cn('icon', 'icon-menu1', 'icon-pointer', styles.menu)} />
        <h1 className={cn(styles.text, 'DINPro-Medium')}>{text}</h1>
        {/* <span className={cn('icon', 'icon-down', styles.down)} /> */}
        <Icon name='arrowDown' className={styles.down} />
      </div>
      <Popover content={<Synopsis {...coinDetail} />} hasArrow overlayClassName={styles.popover} placement="topLeft" align={{ targetOffset: ['12%', '45%'] }} >
        <h2 className={styles.desc}>{I18n.t('profile_my_profile_status')}</h2>
      </Popover>
      <SearchDrawer
        visible={visible}
        setVisible={setVisible}
      />
    </div>
  )
}
